export const ADMIN_EMAILS = ['sydlawrence@gmail.com', 'test.pro@delphina.money'];

// Trial lengths in days (match server SIGNUP_TRIAL_DAYS / UPGRADE_TRIAL_DAYS).
// 0 disables that trial; unset or invalid values fall back to the default.
// Each env var is read literally so Next.js can inline it at build time.
const readTrialDays = (raw: string | undefined, fallback: number) => {
  const parsed = parseInt(raw ?? '', 10);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
};

// No-card Investor trial every new user gets at signup.
export const SIGNUP_TRIAL_DAYS = readTrialDays(process.env.NEXT_PUBLIC_SIGNUP_TRIAL_DAYS, 7);

// Stripe trial on a paid upgrade; 0 means upgrading charges straight away.
export const UPGRADE_TRIAL_DAYS = readTrialDays(process.env.NEXT_PUBLIC_UPGRADE_TRIAL_DAYS, 0);

// Label for upgrade buttons, which only mention a trial when one applies.
export const UPGRADE_CTA = UPGRADE_TRIAL_DAYS > 0
  ? `Start ${UPGRADE_TRIAL_DAYS}-Day Free Trial`
  : 'Upgrade now';
